import React from "react"
import Fieldset from "@paprika/form-element"
import Checkbox from "@paprika/checkbox"
import UnitContentWithPricing from "../unitTypeWithPrice/unitTypeWithPrice"
import "./unitTypeFilter.scss"

const { Label, Content } = Fieldset

export default function UnitTypeFilter(props) {
  const { CHECKED, UNCHECKED } = Checkbox.types.state

  const [checkedState, setCheckedState] = React.useState(props.unitTypes.map(() => CHECKED))

  const handleChange = (index) => {
    const checkedStateCopy = [...checkedState]
    checkedStateCopy[index] = checkedStateCopy[index] === CHECKED ? UNCHECKED : CHECKED
    setCheckedState(checkedStateCopy)
    props.onChange({ e: checkedStateCopy })
  }

  const renderUnitContentWithPricing = (item) => (
    <UnitContentWithPricing
      numOfAvailableMarkersByType={props.numOfAvailableMarkersByType}
      item={item}
      isPricingShowing={props.isPricingShowing}
      shouldAllPitchesShowRemaining={props.shouldAllPitchesShowRemaining}
      onBookNow={props.onUnitTypeBook}
      isPitchBookingLimited={props.isPitchBookingLimited}
    />
  )

  const renderFilterOptions = (a11yProps) => {
    if (props.unitTypes) {
      return props.unitTypes.map((item, index) => (
        <div key={`${item.unitId} ${item.name}`}>
          {!props.hideFilter ? (
            <Checkbox
              style={{ marginTop: "8px", paddingLeft: "2px" }}
              onChange={() => handleChange(index)}
              checkedState={checkedState[index]}
              className="unit-type-filter-checkbox"
            >
              <Checkbox.Input {...a11yProps} />
              {renderUnitContentWithPricing(item)}
            </Checkbox>
          ) : (
            renderUnitContentWithPricing(item)
          )}
        </div>
      ))
    }
    return <div>Loading</div>
  }

  return (
    <div className="unit-types-list">
      <Fieldset>
        <Content>{(a11yProps) => renderFilterOptions(a11yProps)}</Content>
      </Fieldset>
    </div>
  )
}
